// Collapsible table functionality
const collapseTables = document.querySelectorAll('.collapse-table');

collapseTables.forEach((container) => {
    const table = container.querySelector('table');
    const button = container.parentElement.querySelector('.cta-collapse');

    if (!table || !button) return;

    const rows = table.querySelectorAll('tbody tr');
    const initialRows = 6;

    if (rows.length <= initialRows) {
        button.style.display = 'none';
        return;
    }

    let collapsedHeight = 0;
    for (let i = 0; i < initialRows && i < rows.length; i++) {
        collapsedHeight += rows[i].offsetHeight;
    }

    collapsedHeight += 2;

    let totalHeight = 0;
    rows.forEach((row) => {
        totalHeight += row.offsetHeight;
    });

    totalHeight += 2;

    container.style.height = `${collapsedHeight}px`;
    container.style.overflow = 'hidden';
    container.style.transition = 'height 0.3s ease-in-out';

    table.style.height = 'auto';
    table.style.overflow = 'visible';

    button.style.display = 'block';
    button.textContent = 'Ver Más +';

    let isExpanded = false;

    button.addEventListener('click', () => {
        if (isExpanded) {
            container.style.height = `${collapsedHeight}px`;
            button.textContent = 'Ver Más +';
            isExpanded = false;
        } else {
            container.style.height = `${totalHeight}px`;
            button.textContent = 'Ver Menos -';
            isExpanded = true;
        }
    });
});
